import { FC, SetStateAction, useCallback, useState } from "react";
import SwitchComponent from "../../../shared/components/form/switch.component.tsx";
import { useSelector } from "react-redux";
import { userSelector } from "../../../store/user.store.ts";
import TFAOnModal from "../../../shared/components/modals/tfa-on.modal.tsx";
import TfaOffModal from "../../../shared/components/modals/tfa-off.modal.tsx";
import PayoutTFAOnModal from "../../../shared/components/modals/payout-2fa-on.modal.tsx";
import Payout2FAOffModal from "../../../shared/components/modals/payout-2fa-off.modal.tsx";

const SecurityPage: FC = () => {
  const [showP2faOnModel, setShowP2faOnModel] = useState<boolean>(false);
  const [showP2faOffModel, setShowP2faOffModel] = useState<boolean>(false);
  const [showTFAOnModel, setShowTFAOnModel] = useState<boolean>(false);
  const [showTFAOffModel, setShowTFAOffModel] = useState<boolean>(false);
  const {
    profile: { isTfaEnabled, isPTfaEnabled },
  } = useSelector(userSelector);

  const twoFAHandler = useCallback(
    (val: SetStateAction<boolean>) => {
      if (val) {
        if (!isTfaEnabled) {
          setShowTFAOnModel(true);
        }
      } else {
        if (isTfaEnabled) {
          setShowTFAOffModel(true);
        }
      }
    },
    [isTfaEnabled],
  );

  const p2faHandler = useCallback(
    (val: SetStateAction<boolean>) => {
      if (val) {
        if (!isPTfaEnabled) {
          setShowP2faOnModel(true);
        }
      } else {
        if (isPTfaEnabled) {
          setShowP2faOffModel(true);
        }
      }
    },
    [isPTfaEnabled],
  );

  return (
    <>
      <div className="p-6 space-y-6 min-h-125 w-full">
        <h2 className="text-2xl text-slate-800 font-bold mb-5">Security</h2>
        <div className="grid grid-cols-7">
          <section className="col-span-7 md:col-span-5 lg:col-span-3">
            <div className="text-lg font-semibold mb-4">
              Two-Factor Authentication
            </div>
            <div className="space-y-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-medium">Global 2FA</div>
                  <p className="text-xs italic">
                    Require two-factor authentication for all protected actions,
                    including any approvals.
                  </p>
                </div>
                <SwitchComponent
                  id="global-2fa-switch"
                  value={isTfaEnabled}
                  onChange={(e) => twoFAHandler(e)}
                />
              </div>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-medium">Approval 2FA</div>
                  <p className="text-xs italic">
                    Require two-factor authentication only when approving
                    operations like payout or whitelist addresses.
                  </p>
                </div>
                <SwitchComponent
                  id="payout-2fa-switch"
                  value={isPTfaEnabled}
                  onChange={(e) => p2faHandler(e)}
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      <TFAOnModal show={showTFAOnModel} setShow={setShowTFAOnModel} />
      <TfaOffModal show={showTFAOffModel} setShow={setShowTFAOffModel} />
      <PayoutTFAOnModal
        isGlobalEnabled={isTfaEnabled}
        show={showP2faOnModel}
        setShow={setShowP2faOnModel}
      />
      <Payout2FAOffModal
        show={showP2faOffModel}
        setShow={setShowP2faOffModel}
      />
    </>
  );
};

export default SecurityPage;
